document.addEventListener("DOMContentLoaded", function () {

  // Menu toggle for submenus
  document.querySelectorAll(".menu-toggle").forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      // Prevent navigation if there are sublinks
      const parent = toggle.closest(".menu-item");
      const submenu = parent.querySelector(".submenu");

      if (submenu) {
        e.preventDefault();
        submenu.classList.toggle("active");
        parent.classList.toggle("open");
      }
    });
  });

  const searchInputs = document.querySelectorAll(".main-search-input");
  const suggestionsBox = document.getElementById("search-suggestions");
  const staticProducts = document.querySelector('.custom-products-container');
  const staticCollections = document.querySelector('.custom-collection-container');
  const mobileSearchBox = document.querySelector('.custom-mobile-searchbar');
  const menuSearchbar = document.querySelector('.custom-search-wrapper .main-search-input');
  const mobileHideSearchPanel = document.querySelector('.hide-search-panel');
  const customSearchWrapper = document.querySelector('.custom-search-wrapper');

  let abortController;
  let latestQuery = "";
  let debounceTimer;


  function getSearchURL(query) {
    const base = window.location.origin + window.routes.predictive_search_url;
    const params = new URLSearchParams({
      q: query,
      "resources[type]": "product,collection",
      "resources[limit]": "5",
      "resources[limit_scope]": "each",
      section_id: "predictive-search",
    });

    return `${base}?${params.toString()}`;
  }
  
  // Hide suggestions when clicking outside
  document.addEventListener("mousedown", (e) => {
    const target = e.target;

    const isInsideInput = [...searchInputs].some(input => input.contains(target));
    const isInsideSuggestions = suggestionsBox?.contains(target);
    const isInsideMobileSearch = mobileSearchBox?.contains(target);

    if (!isInsideInput && !isInsideSuggestions && !isInsideMobileSearch) {
      suggestionsBox?.classList.add("hidden");
    }
  });

  // Focus logic for desktop + mobile
  searchInputs.forEach((input) => {
    input.addEventListener("focus", () => {
      suggestionsBox?.classList.remove("hidden");
    });

    input.addEventListener("click", () => {
      suggestionsBox?.classList.remove("hidden");
    });

    input.addEventListener("input", function (event) {
      const t = event.target.value.trim();
      latestQuery = t;

      const productResultBlock = document.querySelector('.custom-product-block .search-result-data');
      const collectionResultBlock = document.querySelector('.custom-collection-block .search-result-data');

      if (!t) {
        productResultBlock.innerHTML = '';
        collectionResultBlock.innerHTML = '';

        productResultBlock?.classList.add('hidden');
        collectionResultBlock?.classList.add('hidden');

        staticProducts?.classList.remove('hidden');
        staticCollections?.classList.remove('hidden');
        
        const productsHeading = document.querySelector('.top-products-title');
        const collectionsHeading = document.querySelector('.top-collections-title');
        
        if (productsHeading) productsHeading.textContent = 'Top Products';
        if (collectionsHeading) collectionsHeading.textContent = 'Shop By Collections';

        const viewAllWrapper = collectionResultBlock.querySelector('.view-all-btn-wrapper');
        viewAllWrapper?.classList.add('hidden');
        
        return;
      }

      // staticProducts?.classList.add('hidden');
      // staticCollections?.classList.add('hidden');

      if (typeof AbortController !== "undefined") {
        if (abortController) {
          abortController.abort(); // cancel previous
        }
        abortController = new AbortController(); // create new
      }

      const url = getSearchURL(t);

      clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          // performSearch(event.target.value.trim());
        

      fetch(url, { signal: abortController.signal })
      .then(res => res.text())
      .then(html => {
        if (latestQuery !== t) return;

        productResultBlock.innerHTML = html;
        collectionResultBlock.innerHTML = html;

        const hasProducts = productResultBlock.querySelector('.predictive-products-data-wrapper');
        const hasCollections = collectionResultBlock.querySelector('.predictive-collections-data-wrapper');

        // Headings
        const productsHeading = document.querySelector('.top-products-title');
        const collectionsHeading = document.querySelector('.top-collections-title');

        // Only after success, hide static and show dynamic
        if (hasProducts) {
          productResultBlock.classList.remove('hidden');
          productResultBlock?.querySelector('.view-all-btn-wrapper').classList.add('hidden');
          staticProducts?.classList.add('hidden');
          if (productsHeading) productsHeading.textContent = 'Top Products';
        } else {
          productResultBlock.classList.add('hidden');
          staticProducts?.classList.remove('hidden');
          if (productsHeading) productsHeading.textContent = 'No results — try these products';
        }

        if (hasCollections) {
          collectionResultBlock.classList.remove('hidden');
          staticCollections?.classList.add('hidden');
          if (collectionsHeading) collectionsHeading.textContent = 'Shop By Collections';
        } else {
          staticCollections?.classList.remove('hidden');
          if (collectionsHeading) collectionsHeading.textContent = 'No results — try these collections';
          const productsWrapperInsideCollection = collectionResultBlock?.querySelector('.predictive-products-data-wrapper');
          if (!productsWrapperInsideCollection) {
            collectionResultBlock?.classList.add('hidden');
          } else {
            productsWrapperInsideCollection.classList.add('hidden');
          }
        }
      })
      .catch(err => {
        if (err.name !== "AbortError") {
          console.error(err);
        }
      });
      }, 50); // Waits 50ms before searching
    });
  });

  // Handle mobile search box click
  mobileSearchBox.addEventListener('click', function() {
    suggestionsBox?.classList.remove('hidden');
    // document.querySelector('body')?.classList.add('no-scroll');
    const input = document.querySelector('.custom-search-result-container .main-search-input');
    if (input) {
      input.focus();
    }
  });

  mobileHideSearchPanel.addEventListener('click', () => {
    suggestionsBox?.classList.add('hidden');
    // document.querySelector('body')?.classList.remove('no-scroll');
  })

  if (window.innerWidth <= 768) { 
    document.querySelector('.custom-search-wrapper .main-search-input')?.addEventListener('click', () => {
      const input = document.querySelector('.custom-search-result-container .custom-search-header .main-search-input');
      if (input) {
        setTimeout(() => {
          input.focus();
        }, 10);
      }
    });
  }
  else {
     document.querySelector('.custom-search-wrapper .main-search-input')?.addEventListener('click', () => {
      const input = document.querySelector('.custom-search-header .main-search-input');
      if (input) {
        setTimeout(() => {
          input.focus();
        }, 10);
      }
    });
  }
 
  // Handle menu seach bar
  // if (menuSearchbar) {
  //   const handleMenuSearchFocusOrClick = () => {
  //     const parentModal = menuSearchbar.closest(".modal");
  
  //     if (parentModal && parentModal.classList.contains("is-open")) {
  //       parentModal.classList.remove("is-open");
  //       if (typeof parentModal.close === "function") {
  //         parentModal.close();
  //       }
  //     }
  //     // After closing modal, show suggestions
  //     suggestionsBox?.classList.remove("hidden");
  //   };

  //   menuSearchbar.addEventListener("focus", handleMenuSearchFocusOrClick);
  //   menuSearchbar.addEventListener("click", handleMenuSearchFocusOrClick);
  // }

});

const urlParams = new URLSearchParams(window.location.search);
const currentTag = urlParams.get("filter.p.tag") ? urlParams.get("filter.p.tag").toLowerCase() : "all";

// Set active class on page load
document.querySelectorAll(".filter-tab").forEach((tab) => {
  const tabFilter = tab.getAttribute("data-filter").toLowerCase();
  if (
    (currentTag === "all" && tabFilter === "all") ||
    (tabFilter.replace(/\s+/g, " ") === currentTag)
  ) {
    tab.classList.add("filter-tab-active");
  } else {
    tab.classList.remove("filter-tab-active");
  }
});

document.addEventListener("click", function (e) {
  const tab = e.target.closest(".filter-tab");
  if (!tab) return; 

  document.querySelectorAll(".filter-tab").forEach((t) => t.classList.remove("filter-tab-active"));
  tab.classList.add("filter-tab-active");

  const filter = tab.getAttribute("data-filter");
  const url = new URL(window.location);

  const tagValue = filter.replace(/\s+/g, " ");
  url.searchParams.set("filter.p.tag", tagValue);

  // window.history.pushState({}, "", url);
  window.location.href = url;
});


//B3G1 FREE BAR----------------------------------------------------------------- 1 Jun 2026

const originalFetch = window.fetch;

window.fetch = async function (input, init = {}) {
  try {
    let url = "";

    if (typeof input === "string") {
      url = input;
    } else if (input && typeof input.url === "string") {
      url = input.url;
    } else {
      url = ""; 
    }

    const response = await originalFetch(input, init);

    if (url.includes("/cart/change") || url.includes("/cart/add") || url.includes("/cart/update")) {
      const event = new CustomEvent("cart:updated", { detail: { url } });
      document.dispatchEvent(event);
    }

    return response;
  } catch (error) {
    console.error("Error in custom fetch:", error);
    throw error;
  }
};

async function getCartRewardData() {
  return fetch("/cart.json", {
    headers: { "x-bypass-intercept": "1" },
  })
    .then((res) => res.json())
    .catch(() => ({ total_price: 0 }));
}

let progressBarInitialized = false;
let lastProgressBarValue = 0;
let step_4_intializing = false;
let step_3_intializing = false;
let step_2_intializing = false;
let step_1_intializing = false;

function createProgressBar(container, percent) {
  if (!container) return;

  container.innerHTML = `
    <div class="gocart-rewardbar-container" id="rewardbarSteps">
      <div class="gocart-steps-cover">
        <div class="gocart-steps-wrapper step1">
          <h2 class="gocart-step-title">1 ITEM</h2>
          <p class="gocart-step-count">START</p>
        </div>
        <div class="gocart-steps-wrapper step2">
          <h2 class="gocart-step-title">2 ITEMS</h2>
          <p class="gocart-step-count">HALFWAY</p>
        </div>
        <div class="gocart-steps-wrapper step3">
          <h2 class="gocart-step-title">3 ITEMS</h2>
          <p class="gocart-step-count">ONE MORE</p>
        </div>
        <div class="gocart-steps-wrapper step4">
          <h2 class="gocart-step-title">4 ITEMS</h2>
          <p class="gocart-step-count">4TH FREE</p>
        </div>
      </div>

      <div class="gocart-rewardbar-wrapper" id="gocart-rewardbar-wrapper">
        <div class="gocart-tick-icon step1">
          <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="black" />
          </svg>
        </div>
        <div class="gocart-tick-icon step2">
          <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="black" />
          </svg>
        </div>
        <div class="gocart-tick-icon step3">
          <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="black" />
          </svg>
        </div>
        <div class="gocart-tick-icon step4">
          <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="black" />
          </svg>
        </div>
        <progress class="gocart-reward-bar" id="gocart-reward-progress-bar" value="${percent}" min="0" max="100"></progress>
      </div>

      <div class="gocart-steps-msg-wrapper">
        <span class="gocart-steps-msg"></span>
      </div>
    </div>
  `;
  progressBarInitialized = true;
}

function updateCartMessage(itemCount) {
  const messageElements = document.querySelectorAll(
    "#gocart-cartmessage .cartmsg-wrapper p"
  );

  if (!messageElements.length) return;

  // const message =
  //   itemCount < 2
  //     ? "BUY 2 GET $50 OFF"
  //     : "BUY 3 GET 1 FREE";
  const message = "BUY 3 • GET 1 FREE";

  messageElements.forEach((element) => {
    element.textContent = message;
  });
}

function getProgressBarElements() {
  return {
    progressBar: document.getElementById("gocart-reward-progress-bar"),
    step1: document.querySelector(".gocart-steps-wrapper.step1"),
    step2: document.querySelector(".gocart-steps-wrapper.step2"),
    step3: document.querySelector(".gocart-steps-wrapper.step3"),
    step4: document.querySelector(".gocart-steps-wrapper.step4"),
    tick1: document.querySelector(".gocart-tick-icon.step1 svg path"),
    tick2: document.querySelector(".gocart-tick-icon.step2 svg path"),
    tick3: document.querySelector(".gocart-tick-icon.step3 svg path"),
    tick4: document.querySelector(".gocart-tick-icon.step4 svg path"),
    tickmark1: document.querySelector(".gocart-tick-icon.step1"),
    tickmark2: document.querySelector(".gocart-tick-icon.step2"),
    tickmark3: document.querySelector(".gocart-tick-icon.step3"),
    tickmark4: document.querySelector(".gocart-tick-icon.step4"),
  };
}

async function updateProgressBar(init = false) {
  const cartdetails = await getCartRewardData();
  const cartValue = cartdetails.items_subtotal_price || 0;

  const { progressBar, step1, step2, step3, step4, tick1, tick2, tick3, tick4, tickmark1, tickmark2, tickmark3, tickmark4 } =
    getProgressBarElements();
  if (!progressBar) return;

  const itemCount = cartdetails?.item_count || 0;
  // Max items required for 100%
  const MAX_ITEMS = 4;

  // Calculate progress percentage
  let newPercent = Math.min((itemCount / MAX_ITEMS) * 100, 100);

  if (init) {
    progressBar.value = newPercent;
    lastProgressBarValue = newPercent;
  } else {
    const start = lastProgressBarValue;
    const diff = newPercent - start;
    const duration = 400;
    const startTime = performance.now();

    const animate = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      progressBar.value = start + diff * progress;
      if (progress < 1) requestAnimationFrame(animate);
      else lastProgressBarValue = newPercent;
    };

    requestAnimationFrame(animate);
  }

  const step1Active = cartdetails?.item_count >= 1;
  tick1?.setAttribute("fill", step1Active ? "white" : "black");
  tickmark1?.classList.toggle("single-active", step1Active);
  step_1_intializing = step1Active;

  const step2Active = cartdetails?.item_count >= 2;
  tick2?.setAttribute("fill", step2Active ? "white" : "black");
  tickmark2?.classList.toggle("single-active", step2Active);
  step_2_intializing = step2Active;

  const step3Active = cartdetails?.item_count >= 3;
  tick3?.setAttribute("fill", step3Active ? "white" : "black");
  tickmark3?.classList.toggle("single-active", step3Active);
  step_3_intializing = step3Active;

  const step4Active = cartdetails?.item_count >= MAX_ITEMS;
  tick4?.setAttribute("fill", step4Active ? "white" : "black");
  tickmark4?.classList.toggle("single-active", step4Active);
  step_4_intializing = step4Active;

  const messageEl = document.querySelector(".gocart-steps-msg-wrapper .gocart-steps-msg");

  if (messageEl) {
    if (itemCount === 1) {
      messageEl.innerHTML = `Add 3 more for your free 4th piece.`;
      // messageEl.innerHTML = `Add 1 more to save $50.`;
    } else if (itemCount === 2) {
      // messageEl.innerHTML = `
      //   <span class="gocart-msg-tick">
      //     <svg width="10" height="10" viewBox="0 0 22 17" fill="none">
      //       <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="#D32F2F"/>
      //     </svg>
      //   </span>
      //   $50 OFF unlocked. Add 2 more for a free piece.
      // `;
      messageEl.innerHTML = `Add 2 more for your free 4th piece.`;

    } else if (itemCount === 3) {
      messageEl.innerHTML = `Your next piece is FREE — add your 4th now.`;
    } else if (itemCount >= 4) {
      messageEl.innerHTML = `
        <span class="gocart-msg-tick">
          <svg width="10" height="10" viewBox="0 0 22 17" fill="none">
            <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="#D32F2F"/>
          </svg>
        </span>
        Unlocked — your 4th piece is FREE!
      `;
    } else {
      messageEl.innerHTML = "";
    }
  }
  
}

const progressBarcontainer = document.getElementById("gocart-progressbar");
if (progressBarcontainer) createProgressBar(progressBarcontainer, lastProgressBarValue);
updateProgressBar(true);

let storedBar = null;
const observer = new MutationObserver(() => {
  const container = document.getElementById("gocart-progressbar");
  const rewardSteps = document.getElementById("rewardbarSteps");

  if (container && !rewardSteps && storedBar) {
    container.appendChild(storedBar);
  }

  if (container && !document.getElementById("rewardbarSteps")) {
    createProgressBar(container, lastProgressBarValue);
    updateProgressBar(true);
  }

  storedBar = document.getElementById("rewardbarSteps");
});

observer.observe(document.body, { childList: true, subtree: true });
document.addEventListener("cart:updated", () => updateProgressBar(false));

//B3G1 FREE BAR END ----------------------------------------------------------------- 1 Jun 2026



//B3G1 FREE BAR----------------------------------------------------------------- 1 Feb 2026

// const originalFetch = window.fetch;

// window.fetch = async function (input, init = {}) {
//   try {
//     let url = "";

//     if (typeof input === "string") {
//       url = input;
//     } else if (input && typeof input.url === "string") {
//       url = input.url;
//     } else {
//       url = ""; 
//     }

//     const response = await originalFetch(input, init);

//     if (url.includes("/cart/change") || url.includes("/cart/add") || url.includes("/cart/update")) {
//       const event = new CustomEvent("cart:updated", { detail: { url } });
//       document.dispatchEvent(event);
//     }

//     return response;
//   } catch (error) {
//     console.error("Error in custom fetch:", error);
//     throw error;
//   }
// };

// async function getCartRewardData() {
//   return fetch("/cart.json", {
//     headers: { "x-bypass-intercept": "1" },
//   })
//     .then((res) => res.json())
//     .catch(() => ({ total_price: 0 }));
// }

// function formatMoney(amount) {
//   return Number(amount.toFixed(2)).toString();
// }

// let progressBarInitialized = false;
// let lastProgressBarValue = 0;
// let step_4_intializing = false;
// let step_3_intializing = false;
// let step_2_intializing = false;
// let step_1_intializing = false;

// function createProgressBar(container, percent) {
//   if (!container) return;

//   container.innerHTML = `
//     <div class="gocart-rewardbar-container" id="rewardbarSteps">
//       <div class="gocart-steps-cover">
//         <div class="gocart-steps-wrapper step1">
//           <h2 class="gocart-step-title">START <br>YOUR WALL</h2>
//         </div>
//         <div class="gocart-steps-wrapper step2">
//           <h2 class="gocart-step-title">
//             <div class="offer-top">SPEND $200</div>
//             <div class="offer-middle">
//               <span></span>
//               <small>GET</small>
//               <span></span>
//             </div>
//             <div class="offer-bottom">$30 OFF</div>
//           </h2>
//         </div>
//         <div class="gocart-steps-wrapper step3">
//           <h2 class="gocart-step-title">
//             <div class="offer-top">SPEND $500</div>
//             <div class="offer-middle">
//               <span></span>
//               <small>GET</small>
//               <span></span>
//             </div>
//             <div class="offer-bottom">$100 OFF</div>
//           </h2>
//         </div>
//         <div class="gocart-steps-wrapper step4">
//           <h2 class="gocart-step-title">
//             <div class="offer-top">SPEND $900</div>
//             <div class="offer-middle">
//               <span></span>
//               <small>GET</small>
//               <span></span>
//             </div>
//             <div class="offer-bottom">$200 OFF</div>
//           </h2>
//         </div>
//       </div>

//       <div class="gocart-rewardbar-wrapper" id="gocart-rewardbar-wrapper">
//         <div class="gocart-tick-icon step1">
//           <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="black" />
//           </svg>
//         </div>
//         <div class="gocart-tick-icon step2">
//           <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="black" />
//           </svg>
//         </div>
//         <div class="gocart-tick-icon step3">
//           <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="black" />
//           </svg>
//         </div>
//         <div class="gocart-tick-icon step4">
//           <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="black" />
//           </svg>
//         </div>
//         <progress class="gocart-reward-bar" id="gocart-reward-progress-bar" value="${percent}" min="0" max="100"></progress>
//       </div>

//       <div class="gocart-steps-msg-wrapper">
//         <span class="gocart-steps-msg"></span>
//       </div>
//     </div>
//   `;
//   progressBarInitialized = true;
// }

// function updateCartMessage(itemCount) {
//   const messageElements = document.querySelectorAll(
//     "#gocart-cartmessage .cartmsg-wrapper p"
//   );

//   if (!messageElements.length) return;

//   // const message =
//   //   itemCount < 2
//   //     ? "BUY 2 GET $50 OFF"
//   //     : "BUY 3 GET 1 FREE";

//   const message = "4TH OF JULY SALE"

//   messageElements.forEach((element) => {
//     element.textContent = message;
//   });
// }

// function getProgressBarElements() {
//   return {
//     progressBar: document.getElementById("gocart-reward-progress-bar"),
//     step1: document.querySelector(".gocart-steps-wrapper.step1"),
//     step2: document.querySelector(".gocart-steps-wrapper.step2"),
//     step3: document.querySelector(".gocart-steps-wrapper.step3"),
//     step4: document.querySelector(".gocart-steps-wrapper.step4"),
//     tick1: document.querySelector(".gocart-tick-icon.step1 svg path"),
//     tick2: document.querySelector(".gocart-tick-icon.step2 svg path"),
//     tick3: document.querySelector(".gocart-tick-icon.step3 svg path"),
//     tick4: document.querySelector(".gocart-tick-icon.step4 svg path"),
//     tickmark1: document.querySelector(".gocart-tick-icon.step1"),
//     tickmark2: document.querySelector(".gocart-tick-icon.step2"),
//     tickmark3: document.querySelector(".gocart-tick-icon.step3"),
//     tickmark4: document.querySelector(".gocart-tick-icon.step4"),
//   };
// }

// function calculateProgress(cartValue) {
//   const milestones = [
//     { amount: 0, progress: 0 },
//     { amount: 200, progress: 33.3333 },
//     { amount: 500, progress: 66.6667 },
//     { amount: 900, progress: 100 }
//   ];

//   if (cartValue >= milestones[milestones.length - 1].amount) {
//     return 100;
//   }

//   for (let i = 0; i < milestones.length - 1; i++) {
//     const current = milestones[i];
//     const next = milestones[i + 1];

//     if (cartValue >= current.amount && cartValue <= next.amount) {
//       const ratio =
//         (cartValue - current.amount) /
//         (next.amount - current.amount);

//       return current.progress + ratio * (next.progress - current.progress);
//     }
//   }

//   return 0;
// }

// async function updateProgressBar(init = false) {
//   const cartdetails = await getCartRewardData();
//   // const cartValue = cartdetails.items_subtotal_price || 0;

//   const { progressBar, step1, step2, step3, step4, tick1, tick2, tick3, tick4, tickmark1, tickmark2, tickmark3, tickmark4 } =
//     getProgressBarElements();
//   if (!progressBar) return;

//   // const itemCount = cartdetails?.item_count || 0;
//   // // Max items required for 100%
//   // const MAX_ITEMS = 4;

//   // // Calculate progress percentage
//   // let newPercent = Math.min((itemCount / MAX_ITEMS) * 100, 100);

//   const cartValue = (cartdetails?.items_subtotal_price || 0) / 100; // Shopify returns cents
//   let newPercent = 25;

//   if (cartValue >= 900) {
//     newPercent = 100;
//   } else if (cartValue >= 500) {
//     newPercent = 75;
//   } else if (cartValue >= 200) {
//     newPercent = 50;
//   } else {
//     newPercent = 25;
//   }

//   if (init) {
//     progressBar.value = newPercent;
//     lastProgressBarValue = newPercent;
//   } else {
//     const start = lastProgressBarValue;
//     const diff = newPercent - start;
//     const duration = 400;
//     const startTime = performance.now();

//     const animate = (now) => {
//       const progress = Math.min((now - startTime) / duration, 1);
//       progressBar.value = start + diff * progress;
//       if (progress < 1) requestAnimationFrame(animate);
//       else lastProgressBarValue = newPercent;
//     };

//     requestAnimationFrame(animate);
//   }

//   // const step1Active = cartdetails?.item_count >= 1;
//   // tick1?.setAttribute("fill", step1Active ? "white" : "black");
//   // tickmark1?.classList.toggle("single-active", step1Active);
//   // step_1_intializing = step1Active;

//   // const step2Active = cartdetails?.item_count >= 2;
//   // tick2?.setAttribute("fill", step2Active ? "white" : "black");
//   // tickmark2?.classList.toggle("single-active", step2Active);
//   // step_2_intializing = step2Active;

//   // const step3Active = cartdetails?.item_count >= 3;
//   // tick3?.setAttribute("fill", step3Active ? "white" : "black");
//   // tickmark3?.classList.toggle("single-active", step3Active);
//   // step_3_intializing = step3Active;

//   // const step4Active = cartdetails?.item_count >= MAX_ITEMS;
//   // tick4?.setAttribute("fill", step4Active ? "white" : "black");
//   // tickmark4?.classList.toggle("single-active", step4Active);
//   // step_4_intializing = step4Active;

//   const step1Active = true;
//   const step2Active = cartValue >= 200;
//   const step3Active = cartValue >= 500;
//   const step4Active = cartValue >= 900;

//   tick1?.setAttribute("fill", step1Active ? "white" : "black");
//   tickmark1?.classList.toggle("single-active", step1Active);

//   tick2?.setAttribute("fill", step2Active ? "white" : "black");
//   tickmark2?.classList.toggle("single-active", step2Active);

//   tick3?.setAttribute("fill", step3Active ? "white" : "black");
//   tickmark3?.classList.toggle("single-active", step3Active);

//   tick4?.setAttribute("fill", step4Active ? "white" : "black");
//   tickmark4?.classList.toggle("single-active", step4Active);

//   const messageEl = document.querySelector(".gocart-steps-msg-wrapper .gocart-steps-msg");

//   // if (messageEl) {
//   //   if (itemCount === 1) {
//   //     messageEl.innerHTML = `Add 1 more to save $50.`;
//   //   } else if (itemCount === 2) {
//   //     messageEl.innerHTML = `
//   //       <span class="gocart-msg-tick">
//   //         <svg width="10" height="10" viewBox="0 0 22 17" fill="none">
//   //           <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="#D32F2F"/>
//   //         </svg>
//   //       </span>
//   //       $50 OFF unlocked. Add 2 more for a free piece.
//   //     `;
//   //   } else if (itemCount === 3) {
//   //     messageEl.innerHTML = `Add 1 more for your free 4th piece.`;
//   //   } else if (itemCount >= 4) {
//   //     messageEl.innerHTML = `
//   //       <span class="gocart-msg-tick">
//   //         <svg width="10" height="10" viewBox="0 0 22 17" fill="none">
//   //           <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="#D32F2F"/>
//   //         </svg>
//   //       </span>
//   //       Your 4th piece is free!
//   //     `;
//   //   } else {
//   //     messageEl.innerHTML = "";
//   //   }
//   // }

//   if (messageEl) {
//     if (cartValue < 200) {
//       const remaining = formatMoney(200 - cartValue);
//       messageEl.innerHTML = `Spend $${remaining} more to unlock $30 off.`;
//     } else if (cartValue < 500) {
//       const remaining = formatMoney(500 - cartValue);
//       // messageEl.innerHTML = `
//       //   <span class="gocart-msg-tick">
//       //     <svg width="10" height="10" viewBox="0 0 22 17" fill="none">
//       //       <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="#D32F2F"/>
//       //     </svg>
//       //   </span>
//       //   Add $${remaining} more to unlock $100 OFF.
//       // `;
//       messageEl.innerHTML = `Spend $${remaining} more to unlock $100 off.`;
//     } else if (cartValue < 900) {
//       const remaining = formatMoney(900 - cartValue);
//       // messageEl.innerHTML = `
//       //   <span class="gocart-msg-tick">
//       //     <svg width="10" height="10" viewBox="0 0 22 17" fill="none">
//       //       <path d="M0 9.06667L2.2 6.8L7.7 12.4667L19.8 0L22 2.26667L7.7 17L0 9.06667Z" fill="#D32F2F"/>
//       //     </svg>
//       //   </span>
//       //   Add $${remaining} more to unlock $200 OFF.
//       // `;
//       messageEl.innerHTML = `Add $${remaining} more to unlock $200 off.`;
//     } else {
//       messageEl.innerHTML = "";
//     }
//   }
// }

// const progressBarcontainer = document.getElementById("gocart-progressbar");
// if (progressBarcontainer) createProgressBar(progressBarcontainer, lastProgressBarValue);
// updateProgressBar(true);

// let storedBar = null;
// const observer = new MutationObserver(() => {
//   const container = document.getElementById("gocart-progressbar");
//   const rewardSteps = document.getElementById("rewardbarSteps");

//   if (container && !rewardSteps && storedBar) {
//     container.appendChild(storedBar);
//   }

//   if (container && !document.getElementById("rewardbarSteps")) {
//     createProgressBar(container, lastProgressBarValue);
//     updateProgressBar(true);
//   }

//   storedBar = document.getElementById("rewardbarSteps");
// });

// observer.observe(document.body, { childList: true, subtree: true });
// document.addEventListener("cart:updated", () => updateProgressBar(false));

//B3G1 FREE BAR END ----------------------------------------------------------------- 1 Feb 2026
